export default {
  params: {
    urlBase: 'https://brincaracademia.com.br',
    privacyPolicy: 'pdf politica privacidade',
    apiBase: 'https://api.brincaracademia.com.br/api'
  },
};